export function generateAMCID() {
  return `AMC-${Date.now().toString(36)}`;
}

export function generateBookingID() {
  return `BK-${Math.random().toString(36).slice(2, 9).toUpperCase()}`;
}